import type { OnDestroy } from '@angular/core';
import { Injectable } from '@angular/core';
import type { SubscriptionLike } from 'rxjs';
import { Subscription } from 'rxjs';

@Injectable()
export class Unsubscribable implements OnDestroy {
  private _subscriptions: Subscription = new Subscription();

  protected set _sub(sub: SubscriptionLike | undefined) {
    if (Boolean(sub)) {
      this._subscriptions.add(sub);
    }
  }

  public ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
